import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

export const task: Task = {
  id: "a6d35904-effa-4cf9-9f37-fc5c2a09c17a",
  solutionType: "custom012100",
  type: "custom012100",
  options: {
    targetPointLocation: [4, 3],
  },
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "custom012100",
  data: {
    indexes: [
      [0, 0],
      [0, 1],
      [1, 0],
      [1, 1],
      [2, 0],
      [2, 1],
    ],
  },
};
